'use client';

import Link from 'next/link';
import Image from 'next/image';

export default function RelatedPosts({ relatedPosts, formatDate }) {
  if (!relatedPosts || relatedPosts.length === 0) return null;

  return (
    <div className="mt-10 pt-8">
      <h3 className="text-xl font-semibold mb-6 text-foreground">Related Posts</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
        {relatedPosts.map((relatedPost) => (
          <Link
            key={relatedPost._id}
            href={relatedPost.type === 'page' ? `/${relatedPost.slug}` : `/p/${relatedPost.type}/${relatedPost.slug}`}
            className="block group"
          >
            <div className="flex gap-4 p-4 rounded-lg hover:bg-muted/50 transition-colors border border-border shadow-sm">
              {relatedPost.featuredImage && (
                <div className="relative w-24 h-20 sm:w-28 sm:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                  <Image
                    src={relatedPost.featuredImage}
                    alt={relatedPost.title}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <h4 className="text-base font-medium text-foreground group-hover:text-primary transition-colors line-clamp-2 mb-2">
                  {relatedPost.title}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {formatDate(relatedPost.publishDate || relatedPost.createdAt)}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
